import { render } from "./sysConfig.vue?vue&type=template&id=6bcdcc56&scoped=true"
import script from "./sysConfig.vue?vue&type=script&lang=js"
export * from "./sysConfig.vue?vue&type=script&lang=js"

import "./sysConfig.vue?vue&type=style&index=0&id=6bcdcc56&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcdcc56"]])

export default __exports__